module.exports = __webpack_public_path__ + "static/dao-af8fbf23880bebd7dbd091726027d5fc.png";